const INFO_TOOLTIP_TEXT = "activation.home.competitors.section.tooltip.text";
const COMPETITORS_INFO_TOOLTIP_TEXT = "activation.home.competitors.dropdown.tooltip.text";
export const PLACEHOLDER_TEXT = "activation.home.competitors.placeholder.text";
export const COMPETITORS_TITLE = "activation.home.competitors.title.text";
const AUTOCOMPLETE_TITLE_SIMILAR = "activation.home.competitors.autocomplete.title.similar";
export const COMPETITORS_SUB_TITLE = "activation.home.competitors.subtitle.text";
const AUTOCOMPLETE_TITLE_SEARCHED = "common.suggested.websites";
export const LIMIT_EXCEEDED = "activation.home.competitors.limit.exceeded.message.text";
export const LIMIT_REACHED_P1 = "activation.home.competitors.limit.reached.message.text.part1";
export const LIMIT_REACHED_P2 = "activation.home.competitors.limit.reached.message.text.part2";
